package ir.alirezaivaz.finglish.dto

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.LayoutDirection
import finglish.composeapp.generated.resources.Res
import finglish.composeapp.generated.resources.settings_language_en
import finglish.composeapp.generated.resources.settings_language_fa
import ir.alirezaivaz.finglish.ui.theme.montserratTypography
import ir.alirezaivaz.finglish.ui.theme.vazirmatnTypography
import org.jetbrains.compose.resources.StringResource

enum class Language(
    val tag: String,
    val title: StringResource,
    val direction: LayoutDirection,
) {
    English(
        tag = "en-US",
        title = Res.string.settings_language_en,
        direction = LayoutDirection.Ltr,
    ),
    Persian(
        tag = "fa-IR",
        title = Res.string.settings_language_fa,
        direction = LayoutDirection.Rtl,
    );

    companion object {
        val DEFAULT_LANGUAGE = Persian

        fun find(tag: String): Language {
            return entries.find { it.tag == tag.replace('_', '-') }
                ?: DEFAULT_LANGUAGE
        }

        val Language.typography: Typography
            @Composable
            get() {
                return when (this) {
                    English -> montserratTypography()
                    Persian -> vazirmatnTypography()
                }
            }
    }
}
